// Which lines Account's Billing box shows under Manage billing about cancelling. Pure, so a test can import it.
//
// Since 10 Oct nobody cancels a paid product in Stripe's billing page themselves (Adam: "They need to go through me
// directly"; migration 20261010203000 keeps cancel off for every paid product), so member-billing's summary names
// every product they hold in cancel_off. A line about cancelling is only for something that could be cancelled:
// - a fixed-term membership (term_months, the Accelerator, paid monthly), with the board's line;
// - a product on a payment plan (cancel_off_plans), with the plan line;
// - the product the next payment is for (a running subscription that isn't a plan), with the line for a product
//   with no fixed term.
// A one-off purchase has nothing to cancel, so it gets no line. The summary names only the soonest renewal, so a
// second running subscription on a product with no fixed term and no plan (none is sold today) would get no line;
// its cancel is still off in Stripe's billing page.

const names = list => [...new Set((Array.isArray(list) ? list : []).filter(n => typeof n === 'string' && n))]

/** { cancelOff: [{ product_id, name, term_months }], plans: [name] } from member-billing's summary */
export function billingNotes(summary) {
  const all = Array.isArray(summary?.cancel_off) ? summary.cancel_off : []
  const plans = names(summary?.cancel_off_plans)
  const subscribed = summary?.next_payment?.product_name || null
  const cancelOff = all.filter(p => p && (p.term_months || (p.name === subscribed && !plans.includes(p.name))))
  return { cancelOff, plans: plans.filter(n => !cancelOff.some(p => p.name === n)) }
}
